var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoConstructora(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_189",
    "data-name": "Group 189",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209.125,
    height: 174.034,
    viewBox: "0 0 209.125 174.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3, .cls-5 {\n        fill: #193982;\n      }\n\n      .cls-4, .cls-6 {\n        fill: #141413;\n      }\n\n      .cls-4, .cls-5 {\n        fill-rule: evenodd;\n      }\n\n      .cls-7 {\n        fill: #1d0b05;\n      }\n\n      .cls-8 {\n        opacity: 0.5;\n        mix-blend-mode: multiply;\n        isolation: isolate;\n      }\n\n      .cls-9 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-10 {\n        clip-path: url(#clip-path-4);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    className: "cls-1",
    width: 209.125,
    height: 174.034
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    className: "cls-1",
    width: 48.182,
    height: 47.992
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    className: "cls-1",
    d: "M93.825,37.294v0l8.25,9.174,23.642-9.241L111.7,29.984Z",
    transform: "translate(-93.825 -29.984)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.462,
    y1: 4.792,
    x2: -1.446,
    y2: 4.792,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#d2d2d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#626260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#171714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171714"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    className: "cls-3",
    d: "M18.958,299.2v5.585h-.464a5.951,5.951,0,0,0-1.949-3.351,4.984,4.984,0,0,0-3.233-1.166,4.772,4.772,0,0,0-2.77.869A5.076,5.076,0,0,0,8.7,303.41,10.285,10.285,0,0,0,7.95,307.4a13.322,13.322,0,0,0,.548,3.942,5.232,5.232,0,0,0,1.712,2.685,4.752,4.752,0,0,0,3.018.91,5.89,5.89,0,0,0,2.788-.666,9.628,9.628,0,0,0,2.668-2.295v1.389a8.768,8.768,0,0,1-2.822,2.051,8.568,8.568,0,0,1-3.431.635,9.832,9.832,0,0,1-4.581-1.034,7.314,7.314,0,0,1-3.091-2.97,8.3,8.3,0,0,1-1.087-4.124,8.8,8.8,0,0,1,4.464-7.585,8.809,8.809,0,0,1,4.357-1.14,9.891,9.891,0,0,1,3.59.736,5.452,5.452,0,0,0,1.391.428.9.9,0,0,0,.66-.279,1.524,1.524,0,0,0,.362-.885Z",
    transform: "translate(-1.743 -142.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    className: "cls-3",
    d: "M45.567,299.466a8,8,0,0,1,8.664,8.225,8.6,8.6,0,0,1-1.793,5.4,7.984,7.984,0,0,1-6.717,3.09,8.145,8.145,0,0,1-6.728-2.948,8.534,8.534,0,0,1-1.878-5.528,8.041,8.041,0,0,1,2.444-5.985,7.772,7.772,0,0,1,6.008-2.251m.142.76a3.634,3.634,0,0,0-3.365,2.258,12.073,12.073,0,0,0-.939,5.325q0,4.126,1.451,6.1a3.3,3.3,0,0,0,2.829,1.38,3.389,3.389,0,0,0,2.044-.594,4.882,4.882,0,0,0,1.627-2.432,13.464,13.464,0,0,0,.582-4.355,14.489,14.489,0,0,0-.593-4.784,4.661,4.661,0,0,0-1.516-2.241,3.579,3.579,0,0,0-2.121-.654",
    transform: "translate(-17.617 -142.145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    className: "cls-3",
    d: "M77.723,299.9l7.952,9.995v-6.93a3.286,3.286,0,0,0-.416-1.961,2.31,2.31,0,0,0-1.914-.666V299.9H88.67v.439a4.078,4.078,0,0,0-1.372.338,1.368,1.368,0,0,0-.548.68,4.606,4.606,0,0,0-.2,1.609v13.42h-.4l-10.9-13.42v10.247a2.268,2.268,0,0,0,.635,1.88,2.34,2.34,0,0,0,1.456.486h.381v.439H72v-.439a2.589,2.589,0,0,0,1.855-.548,2.552,2.552,0,0,0,.523-1.818V301.842l-.345-.428a3.123,3.123,0,0,0-.9-.844A2.7,2.7,0,0,0,72,300.344V299.9Z",
    transform: "translate(-34.179 -142.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    className: "cls-3",
    d: "M117.386,299.179l.132,5.373h-.489a5.494,5.494,0,0,0-1.694-3.251,4.266,4.266,0,0,0-2.919-1.23,2.727,2.727,0,0,0-1.919.648,1.971,1.971,0,0,0-.707,1.491,1.812,1.812,0,0,0,.25.951,4,4,0,0,0,1.106,1.107,24.794,24.794,0,0,0,2.579,1.391,11.479,11.479,0,0,1,3.814,2.625,4.444,4.444,0,0,1,.976,2.831,4.575,4.575,0,0,1-1.575,3.476,5.656,5.656,0,0,1-4,1.455,6.444,6.444,0,0,1-1.439-.154,10.808,10.808,0,0,1-1.7-.583,2.6,2.6,0,0,0-.939-.237,1.167,1.167,0,0,0-.653.237,1.67,1.67,0,0,0-.559.725h-.441v-6.086h.441a6.991,6.991,0,0,0,2.014,3.918,4.722,4.722,0,0,0,3.216,1.349,3.021,3.021,0,0,0,2.121-.725,2.224,2.224,0,0,0,.79-1.687,2.2,2.2,0,0,0-.3-1.106,3.47,3.47,0,0,0-.921-1.016,13.808,13.808,0,0,0-2.186-1.255,18.834,18.834,0,0,1-3.162-1.843,5.6,5.6,0,0,1-1.479-1.7,4.213,4.213,0,0,1-.517-2.069,4.372,4.372,0,0,1,1.414-3.28,4.951,4.951,0,0,1,3.566-1.356,6.053,6.053,0,0,1,1.521.191,7.439,7.439,0,0,1,1.361.528,3.212,3.212,0,0,0,1.123.387.628.628,0,0,0,.486-.192,2.145,2.145,0,0,0,.334-.915Z",
    transform: "translate(-50.89 -142.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    className: "cls-3",
    d: "M146.738,300.606v4.362h-.429a6.877,6.877,0,0,0-.843-2.169,3.263,3.263,0,0,0-1.272-1.053,4.1,4.1,0,0,0-1.581-.213h-1.2v12.432a5.108,5.108,0,0,0,.137,1.546,1.238,1.238,0,0,0,.536.542,2.171,2.171,0,0,0,1.087.231h.535v.439h-8.441v-.439h.537a2.214,2.214,0,0,0,1.128-.252,1.128,1.128,0,0,0,.486-.567,4.88,4.88,0,0,0,.132-1.5V301.533h-1.165a3.416,3.416,0,0,0-2.367.687,4.57,4.57,0,0,0-1.306,2.747h-.451v-4.362Z",
    transform: "translate(-62.78 -142.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    className: "cls-3",
    d: "M168.367,309.377v4.517a4.993,4.993,0,0,0,.16,1.647,1.181,1.181,0,0,0,.565.54,3.8,3.8,0,0,0,1.509.2v.439h-8.249v-.439a3.717,3.717,0,0,0,1.515-.207,1.229,1.229,0,0,0,.559-.542,4.938,4.938,0,0,0,.161-1.641v-10.46a5,5,0,0,0-.161-1.646,1.19,1.19,0,0,0-.564-.54,3.785,3.785,0,0,0-1.51-.2v-.439h7.489a16.322,16.322,0,0,1,4.278.4,4.307,4.307,0,0,1,2.211,1.489,4.01,4.01,0,0,1,.856,2.552A3.81,3.81,0,0,1,175.9,308a5.315,5.315,0,0,1-2.294,1.105l3.875,5.456a8.15,8.15,0,0,0,1.081,1.319,2.016,2.016,0,0,0,1.13.4v.439h-5.077l-5.194-7.346Zm0-7.9v7.06h.678a7.589,7.589,0,0,0,2.472-.3,2.463,2.463,0,0,0,1.29-1.094,4,4,0,0,0,.47-2.064,3.129,3.129,0,0,0-3.638-3.6Z",
    transform: "translate(-77.065 -142.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    className: "cls-3",
    d: "M196.045,299.881h8.32v.439h-.416a2.922,2.922,0,0,0-1.291.2,1.137,1.137,0,0,0-.5.541,5.841,5.841,0,0,0-.148,1.724v7.892a8.025,8.025,0,0,0,.326,2.865,2.719,2.719,0,0,0,1.077,1.164,3.525,3.525,0,0,0,1.889.464,4.057,4.057,0,0,0,2.228-.587,3.6,3.6,0,0,0,1.378-1.623,9.855,9.855,0,0,0,.459-3.6v-6.572a3.816,3.816,0,0,0-.225-1.544,1.346,1.346,0,0,0-.571-.642,3.367,3.367,0,0,0-1.51-.275v-.439h5.576v.439h-.333a2.135,2.135,0,0,0-1.13.275,1.547,1.547,0,0,0-.655.819,4.141,4.141,0,0,0-.153,1.368V308.9a15.9,15.9,0,0,1-.376,4.1,4.589,4.589,0,0,1-1.824,2.318,6.6,6.6,0,0,1-3.958,1.057,7.525,7.525,0,0,1-3.233-.558,4.766,4.766,0,0,1-2.2-1.951,6.763,6.763,0,0,1-.642-3.2v-7.892a5.592,5.592,0,0,0-.154-1.73,1.161,1.161,0,0,0-.536-.54,3.2,3.2,0,0,0-1.4-.191Z",
    transform: "translate(-93.057 -142.345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    className: "cls-3",
    d: "M245.543,299.2v5.585h-.465a5.942,5.942,0,0,0-1.948-3.351,4.982,4.982,0,0,0-3.233-1.166,4.772,4.772,0,0,0-2.77.869,5.076,5.076,0,0,0-1.843,2.271,10.285,10.285,0,0,0-.749,3.992,13.3,13.3,0,0,0,.548,3.942,5.231,5.231,0,0,0,1.712,2.685,4.754,4.754,0,0,0,3.019.91,5.892,5.892,0,0,0,2.788-.666,9.659,9.659,0,0,0,2.668-2.295v1.389a8.761,8.761,0,0,1-2.823,2.051,8.559,8.559,0,0,1-3.43.635,9.831,9.831,0,0,1-4.581-1.034,7.307,7.307,0,0,1-3.09-2.97,8.3,8.3,0,0,1-1.088-4.124,8.8,8.8,0,0,1,4.464-7.585,8.808,8.808,0,0,1,4.355-1.14,9.887,9.887,0,0,1,3.591.736,5.458,5.458,0,0,0,1.391.428.9.9,0,0,0,.66-.279,1.517,1.517,0,0,0,.361-.885Z",
    transform: "translate(-109.296 -142.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    className: "cls-3",
    d: "M278.043,300.606v4.362h-.429a6.874,6.874,0,0,0-.844-2.169,3.263,3.263,0,0,0-1.272-1.053,4.1,4.1,0,0,0-1.581-.213h-1.2v12.432a5.126,5.126,0,0,0,.137,1.546,1.234,1.234,0,0,0,.536.542,2.169,2.169,0,0,0,1.087.231h.534v.439h-8.44v-.439h.536a2.217,2.217,0,0,0,1.129-.252,1.128,1.128,0,0,0,.487-.567,4.885,4.885,0,0,0,.131-1.5V301.533h-1.165a3.412,3.412,0,0,0-2.367.687,4.57,4.57,0,0,0-1.306,2.747h-.452v-4.362Z",
    transform: "translate(-125.107 -142.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    className: "cls-3",
    d: "M302.221,299.466a7.995,7.995,0,0,1,8.664,8.225,8.6,8.6,0,0,1-1.794,5.4,7.983,7.983,0,0,1-6.716,3.09,8.142,8.142,0,0,1-6.728-2.948,8.528,8.528,0,0,1-1.879-5.528,8.041,8.041,0,0,1,2.444-5.985,7.773,7.773,0,0,1,6.008-2.251m.142.76A3.633,3.633,0,0,0,299,302.484a12.056,12.056,0,0,0-.94,5.325q0,4.126,1.451,6.1a3.307,3.307,0,0,0,2.829,1.38,3.394,3.394,0,0,0,2.045-.594,4.878,4.878,0,0,0,1.626-2.432,13.444,13.444,0,0,0,.584-4.355,14.453,14.453,0,0,0-.595-4.784,4.661,4.661,0,0,0-1.516-2.241,3.576,3.576,0,0,0-2.121-.654",
    transform: "translate(-139.444 -142.145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    className: "cls-3",
    d: "M334.878,309.377v4.517a5.008,5.008,0,0,0,.16,1.647,1.19,1.19,0,0,0,.566.54,3.792,3.792,0,0,0,1.509.2v.439h-8.249v-.439a3.727,3.727,0,0,0,1.516-.207,1.217,1.217,0,0,0,.558-.542,4.882,4.882,0,0,0,.162-1.641v-10.46a4.939,4.939,0,0,0-.162-1.646,1.172,1.172,0,0,0-.564-.54,3.788,3.788,0,0,0-1.51-.2v-.439h7.489a16.322,16.322,0,0,1,4.278.4,4.308,4.308,0,0,1,2.212,1.489,4,4,0,0,1,.856,2.552A3.809,3.809,0,0,1,342.415,308a5.313,5.313,0,0,1-2.3,1.105L344,314.56a8.152,8.152,0,0,0,1.081,1.319,2.019,2.019,0,0,0,1.131.4v.439H341.13l-5.193-7.346Zm0-7.9v7.06h.679a7.589,7.589,0,0,0,2.472-.3,2.461,2.461,0,0,0,1.289-1.094,4.005,4.005,0,0,0,.47-2.064,3.129,3.129,0,0,0-3.638-3.6Z",
    transform: "translate(-156.103 -142.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    className: "cls-3",
    d: "M371.768,311.832h-5.694L365.4,313.4a3.482,3.482,0,0,0-.333,1.3,1.081,1.081,0,0,0,.546,1,4.693,4.693,0,0,0,1.581.284v.439h-5.36v-.439a2.412,2.412,0,0,0,1.427-.719,9.644,9.644,0,0,0,1.378-2.432L370.4,299.97h.225l5.812,13.217a8.107,8.107,0,0,0,1.369,2.367,1.865,1.865,0,0,0,1.14.428v.439h-7.8v-.439h.322a2.455,2.455,0,0,0,1.319-.261.638.638,0,0,0,.262-.549,1.46,1.46,0,0,0-.071-.439c-.016-.074-.135-.368-.356-.892Zm-.4-.877-2.4-5.551-2.472,5.551Z",
    transform: "translate(-171.751 -142.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    className: "cls-4",
    d: "M329.619,171.481l5-12.21a32.633,32.633,0,0,0,6,3.438,13.058,13.058,0,0,0,4.929,1.084,4.5,4.5,0,0,0,2.529-.608,1.876,1.876,0,0,0,.924-1.66c0-1.2-1.532-2.132-4.61-2.761-1-.222-1.773-.387-2.324-.511a13.756,13.756,0,0,1-7.473-4.227A11.223,11.223,0,0,1,332,146.463a14.5,14.5,0,0,1,5.029-11.435q5.033-4.406,13.191-4.41a27.851,27.851,0,0,1,7.391.989,34,34,0,0,1,7.326,2.975l-4.769,11.4a19.333,19.333,0,0,0-4.542-2.546,12.244,12.244,0,0,0-4.416-.875,4.893,4.893,0,0,0-2.534.546,1.7,1.7,0,0,0-.894,1.534c0,1.23,2.173,2.32,6.528,3.24.689.164,1.228.289,1.6.369A12.4,12.4,0,0,1,363,152.392a11.449,11.449,0,0,1,2.589,7.562,15,15,0,0,1-5.225,11.818q-5.227,4.592-13.6,4.586a31.3,31.3,0,0,1-8.571-1.218,38.71,38.71,0,0,1-8.574-3.658",
    transform: "translate(-156.461 -62.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    className: "cls-4",
    d: "M278.665,144.525a21.8,21.8,0,0,0-4.89-7.33,22.707,22.707,0,0,0-7.575-4.887,25.694,25.694,0,0,0-18.332,0,22.477,22.477,0,0,0-7.543,4.887,21.091,21.091,0,0,0-4.906,7.3,23.9,23.9,0,0,0-1.667,9,23.621,23.621,0,0,0,1.667,8.961,21.1,21.1,0,0,0,4.906,7.266,22.626,22.626,0,0,0,7.572,4.944,25.374,25.374,0,0,0,18.238,0,22.818,22.818,0,0,0,7.548-4.88,22.1,22.1,0,0,0,4.97-7.382,23.182,23.182,0,0,0,1.7-8.909,23.469,23.469,0,0,0-1.688-8.966m-16.309,14.939a7.442,7.442,0,0,1-10.659,0,8.608,8.608,0,0,1-2.021-5.974,8.738,8.738,0,0,1,2.021-6.01,7.356,7.356,0,0,1,10.659-.022,8.818,8.818,0,0,1,2.009,6.032,8.652,8.652,0,0,1-2.009,5.974",
    transform: "translate(-110.956 -62.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    className: "cls-4",
    d: "M146.2,176.36V130.623h15.365v19.494l10.427-19.494h18.621l-13.806,22.522,15.748,23.215h-19.9l-11.09-19.122V176.36Z",
    transform: "translate(-69.397 -62.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    className: "cls-4",
    d: "M45.48,144.527a21.79,21.79,0,0,0-4.885-7.328,22.863,22.863,0,0,0-7.573-4.893,24.719,24.719,0,0,0-9.17-1.684,24.725,24.725,0,0,0-9.17,1.684A22.562,22.562,0,0,0,7.142,137.2a21.265,21.265,0,0,0-4.909,7.3,23.991,23.991,0,0,0-1.668,9,23.734,23.734,0,0,0,1.668,8.964,21.364,21.364,0,0,0,4.909,7.265,22.608,22.608,0,0,0,7.573,4.941,24.494,24.494,0,0,0,9.138,1.7,24.468,24.468,0,0,0,9.1-1.7,22.727,22.727,0,0,0,7.549-4.877,22.18,22.18,0,0,0,4.972-7.383,23.136,23.136,0,0,0,1.7-8.909,23.446,23.446,0,0,0-1.692-8.964m-16.308,14.94a6.81,6.81,0,0,1-5.32,2.245,6.855,6.855,0,0,1-5.336-2.245,8.593,8.593,0,0,1-2.024-5.976,8.7,8.7,0,0,1,2.024-6.008,6.769,6.769,0,0,1,5.336-2.3,6.783,6.783,0,0,1,5.32,2.276,8.821,8.821,0,0,1,2.008,6.031,8.661,8.661,0,0,1-2.008,5.976",
    transform: "translate(-0.268 -62.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    className: "cls-5",
    d: "M.565,55.023.627,66.58,82.1,34.747l68.253,31.629h58.489l-94.7-41.8H74.969Z",
    transform: "translate(-0.268 -11.664)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    className: "cls-6",
    width: 15.365,
    height: 45.737,
    transform: "translate(53.295 68.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    className: "cls-7",
    d: "M375.827,24.574a7.928,7.928,0,1,0,7.93,7.926,7.936,7.936,0,0,0-7.93-7.926m0,15.306a7.378,7.378,0,1,1,7.38-7.38,7.388,7.388,0,0,1-7.38,7.38",
    transform: "translate(-174.632 -11.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    className: "cls-7",
    d: "M376.4,40.071V31.4h3.688a6.255,6.255,0,0,1,2.018.236,2,2,0,0,1,1.009.829,2.5,2.5,0,0,1,.378,1.368,2.306,2.306,0,0,1-.575,1.612,2.732,2.732,0,0,1-1.712.8,4.133,4.133,0,0,1,.936.731,9.791,9.791,0,0,1,1,1.406l1.062,1.691h-2.1l-1.266-1.886a12.333,12.333,0,0,0-.924-1.275,1.361,1.361,0,0,0-.525-.362,2.928,2.928,0,0,0-.884-.1h-.351v3.621Zm1.754-5.005h1.292a6.913,6.913,0,0,0,1.575-.1.98.98,0,0,0,.491-.368,1.134,1.134,0,0,0,.179-.652,1.049,1.049,0,0,0-.233-.7,1.1,1.1,0,0,0-.662-.344c-.143-.015-.569-.026-1.278-.026h-1.364Z",
    transform: "translate(-178.668 -14.904)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    className: "cls-8",
    transform: "translate(41.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(8.146 15.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    className: "cls-11",
    width: 33.251,
    height: 34.96,
    transform: "translate(-8.143 9.534) rotate(-49.501)"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    className: "cls-6",
    width: 209.125,
    height: 15.365,
    transform: "translate(0 128.397)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoConstructora);
export default __webpack_public_path__ + "static/media/logo-constructora.0272afe43def70f9ba02c73cad98a3cb.svg";
export { ForwardRef as ReactComponent };